<template>
  <v-container
    id="dashboard"
    tag="section"
  >
    <v-row justify="center">
      <v-col
        cols="12"
      >
        <base-material-card
          title="Продукты и решения"
          color="primary"
          icon="mdi-border-all"
          inline
        >
          <v-container>
            <v-row justify="center">
              <v-col
                cols="12"
              >
                <p style="text-align:center; font-size: 34px;">
                  Торговый эквайринг
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="7"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-icon
                      size="80"
                      style=" width: 100%; height: 100%;"
                    >
                      mdi-monitor-dashboard
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <p style="font-size:18px;">
                      Управленческий учет
                    </p>
                    <p>
                      Мониторинг устройств и получение статистической инфомации о совершаемых операция во всех точках продаж в режиме 24*7
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-icon
                      size="80"
                      style=" width: 100%; height: 100%;"
                    >
                      mdi-monitor-cellphone
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <p style="font-size:18px;">
                      Мобильность
                    </p>
                    <p>
                      Возможность подключения как стационарных, так и мобильных POS-терминалов и онлайн-касс
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-icon
                      size="80"
                      style=" width: 100%; height: 100%;"
                    >
                      mdi-cloud-print-outline
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <p style="font-size:18px;">
                      Фискализация
                    </p>
                    <p>
                      Реализация возможности фискализации в соответствии с 54-ФЗ в зависимости от типа точек. Для мобильных реализована возможность применения облачных сервисов фискализации.
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                md="5"
              >
                <v-img
                  min-height="100%"
                  max-width="500px"
                  src="/images/product_info_1.jpg"
                  style="margin: auto;"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content:center;">
            <v-btn
              rounded
              color="primary"
              @click="dialog.client.show = true"
            >
              <span class="mx-10">Оставить заявку</span>
            </v-btn>
          </v-card-actions>
          <v-container>
            <v-row justify="center">
              <v-col
                cols="12"
              >
                <p style="text-align:center; font-size: 34px;">
                  Эквайринг для вендинга
                </p>
                <p style="text-align:center; font-size: 20px; max-width: 430px; margin: auto;">
                  Контролируйте и управляйте бизнесом в одном месте
                </p>
              </v-col>
            </v-row>
            <v-row>
              <v-col
                cols="12"
                md="7"
              >
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-icon
                      size="80"
                      style=" width: 100%; height: 100%;"
                    >
                      mdi-devices
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <p style="font-size:18px;">
                      Учет платежей и контроль телеметрии
                    </p>
                    <p>
                      Мониторинг устройств и получение статистической инфомации о совершаемых операция во всех точках продаж в режиме 24*7
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-icon
                      size="80"
                      style=" width: 100%; height: 100%;"
                    >
                      mdi-sale
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <p style="font-size:18px;">
                      Подключение собственных программ лояльности
                    </p>
                    <p>
                      Управляйте своими промо-акциями, создавайте собственные бонусные программы в личном кабинете.
                    </p>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-icon
                      size="80"
                      style=" width: 100%; height: 100%;"
                    >
                      mdi-cloud-print-outline
                    </v-icon>
                  </v-col>
                  <v-col
                    cols="12"
                    md="10"
                  >
                    <p style="font-size:18px;">
                      Фискализация
                    </p>
                    <p>
                      Реализация возможности фискализации в соответствии с 54-ФЗ
                    </p>
                  </v-col>
                </v-row>
              </v-col>
              <v-col
                cols="12"
                md="5"
              >
                <v-img
                  min-height="100%"
                  max-width="500px"
                  src="/images/product_info_2.jpg"
                  style="margin: auto;"
                />
              </v-col>
            </v-row>
          </v-container>
          <v-card-actions style="justify-content:center;">
            <v-btn
              rounded
              color="primary"
              @click="dialog.client.show = true"
            >
              <span class="mx-10">Оставить заявку</span>
            </v-btn>
          </v-card-actions>
        </base-material-card>
      </v-col>
    </v-row>
    <v-dialog
      v-model="dialog.client.show"
      width="800"
    >
      <base-material-card
        color="primary"
        light
        width="800"
      >
        <template v-slot:heading>
          <span class="text-center">Оформление заявки</span>
        </template>
        <v-card-text>
          <v-stepper v-model="stepper.value">
            <v-stepper-header>
              <v-stepper-step
                :complete="stepper.value > 1"
                step="1"
              >
                Введите данные организации
              </v-stepper-step>

              <v-divider />

              <v-stepper-step
                :complete="stepper.value > 2"
                step="2"
              >
                Подтверждение рекизитов
              </v-stepper-step>

              <v-divider />

              <v-stepper-step step="3">
                Дополнительные данные
              </v-stepper-step>
            </v-stepper-header>

            <v-stepper-items>
              <v-stepper-content step="1">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.client.data.legal.name.short"
                      label="Введите наименование, ИНН или ОГРН организации"
                      name="inn"
                      @input="legal_input"
                    />
                  </v-col>
                </v-row>

                <v-btn
                  color="primary"
                  @click="stepper.value = 2"
                >
                  Далее
                </v-btn>

                <v-btn
                  text
                  @click="dialog.client.show = false"
                >
                  Отмена
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="2">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.client.data.legal.name.full"
                      name="legal_name_full"
                      label="Полное наименование"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-text-field
                      v-model="dialog.client.data.legal.ogrn"
                      name="legal_ogrn"
                      label="ОГРН"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="3"
                  >
                    <v-text-field
                      v-model="dialog.client.data.legal.ogrn_date"
                      name="legal_ogrn_date"
                      type="date"
                      label="Дата выдачи ОГРН"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="dialog.client.data.legal.inn"
                      name="legal_inn"
                      label="ИНН"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="dialog.client.data.legal.kpp"
                      name="legal_kpp"
                      label="КПП"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="2"
                  >
                    <v-text-field
                      v-model="dialog.client.data.state_text"
                      name="legal_status"
                      label="Статус"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.client.data.legal.main_okved"
                      name="main_okved"
                      label="Основной вид деятельности"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.client.data.legal.address.unrestricted_value"
                      name="legal_address"
                      label="Юридический адрес"
                    />
                  </v-col>
                </v-row>
                <v-row>
                  <v-col
                    cols="12"
                    md="5"
                  >
                    <v-text-field
                      v-model="dialog.client.data.legal.director.post"
                      name="legal_director_post"
                      label="Должность руководителя"
                    />
                  </v-col>
                  <v-col
                    cols="12"
                    md="7"
                  >
                    <v-text-field
                      v-model="dialog.client.data.legal.director.name"
                      name="legal_director_name"
                      label="ФИО руководителя"
                    />
                  </v-col>
                </v-row>
                <v-btn
                  color="primary"
                  @click="stepper.value = 3"
                >
                  Далее
                </v-btn>

                <v-btn
                  text
                  @click="stepper.value = 1"
                >
                  Отмена
                </v-btn>
              </v-stepper-content>

              <v-stepper-content step="3">
                <v-row>
                  <v-col cols="12">
                    <v-text-field
                      v-model="dialog.client.data.comment"
                      label="Комментарий"
                    />
                  </v-col>
                  <v-col cols="12">
                    Приложите файлы
                  </v-col>
                  <v-col cols="12">
                    <v-form>
                      <v-file-input
                        v-model="import_files"
                        placeholder="Нажмите и укажите необходимые документы"
                        label="Добавить файлы"
                        multiple
                        prepend-icon="mdi-paperclip"
                        @change="upload"
                      >
                        <template v-slot:selection="{ text }">
                          <v-chip
                            small
                            label
                            color="primary"
                          >
                            {{ text }}
                          </v-chip>
                        </template>
                      </v-file-input>
                      <!--  <v-container class="py-0">
                        <v-card
                          class="elevation-1"
                          text
                        >
                          <v-progress-linear
                            class="ma-0"
                            color="secondary"
                            :indeterminate="loader.show"
                          />
                          <v-card-text>
                            <v-data-table
                              hide-default-footer
                              hide-default-header
                              :items="dialog.client.data.files"
                              :headers="headers.file"
                            >
                              <template v-slot:item.save="{item}">
                                <v-icon @click="getDoc(item)">
                                  mdi-content-save
                                </v-icon>
                              </template>
                              <template v-slot:item.comment="{item}">
                                <v-text-field
                                  v-model="item.comment"
                                  :disabled="loader.show"
                                  label="Описание"
                                />
                              </template>
                            </v-data-table>
                          </v-card-text>
                          <v-card-actions class="grey lighten-4">
                            <v-btn
                              color="primary"
                              text
                              :disabled="loader.show"
                              @click="$refs.upload.click()"
                            >
                              Добавить файл
                            </v-btn>
                            <input
                              ref="upload"
                              type="file"
                              style="display: none;"
                              @change="upload"
                            >
                          </v-card-actions>
                        </v-card>
                      </v-container> -->
                    </v-form>
                  </v-col>
                </v-row>
                <v-btn
                  color="primary"
                  @click="create_client"
                >
                  <span class="mx-10">
                    Подать заявку
                  </span>
                </v-btn>

                <v-btn
                  text
                  @click="stepper.value = 2"
                >
                  Отмена
                </v-btn>
              </v-stepper-content>
            </v-stepper-items>
          </v-stepper>
        </v-card-text>
      </base-material-card>
    </v-dialog>
  </v-container>
</template>

<script>
  import $ from 'jquery'
  import moment from 'moment'
  export default {
    name: 'Main',
    data () {
      return {
        headers: {
          file: [
            {
              text: '',
              value: 'save',
            },
            {
              text: 'Название',
              value: 'filename',
            },
            {
              text: 'Описание',
              value: 'comment',
            },
          ],
        },
        loader: {
          show: false,
        },
        import_files: null,
        dialog: {
          client: {
            show: false,
            data: {
              name: '',
              legal: {
                name: {
                  full: '',
                  short: '',
                },
                ogrn: '',
                ogrn_date: '',
                inn: '',
                kpp: '',
                main_okved: '',
                okved: [],
                director: {
                  name: '',
                  post: '',
                },
                tax: {
                  authority: '',
                  system: '',
                },
                address: {
                  unrestricted_value: '',
                },
              },
              files: [],
              state: 0,
            },
          },
        },
        suggestions: {
          legal: false,
        },
        stepper: {
          value: 1,
        },
      }
    },
    methods: {
      create_client: function () {
        this.loader.show = true
        const data = new FormData()
        for (const x in this.import_files) {
          data.append('file', this.import_files[x])
        }
        this.axios
          .post('/api/common/file/', data, {
            headers: {
              'Content-Type': 'multipart/form-data',
            },
          })
          .then(response => {
            if (response.data.error) {
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            } else {
              for (const x in response.data.data) {
                this.dialog.client.data.files.push(response.data.data[x])
              }
              this.axios.post('/api/client/create/', this.dialog.client.data)
                .then(response => {
                  if (!response.data.error) {
                    this.$store.commit('snackbar', 'Заявка успешно отправлена')
                    this.dialog.client.show = false
                  } else {
                    this.$store.commit('snackbar', response.data.data || 'Ошибка при сохранении данных')
                  }
                })
                .catch(e => {
                  this.$store.commit('snackbar', 'Ошибка при сохранении данных')
                })
            }
            this.loader.show = false
          })
          .catch(error => {
            console.log(error)
            this.$store.commit('snackbar', 'Ошибка при сохранении данных')
            this.loader.show = false
          })
      },
      legal_input: function () {
        if (this.suggestions.legal) return
        this.suggestions.legal = true
        $('[name=inn]').suggestions({
          token: 'e34ea0b5db1995676cb5794a9c323e632feead8e',
          type: 'PARTY',
          count: 5,
          onSelect: data => {
            console.log(data)
            this.dialog.client.data.legal.name.full = data.data.name.full_with_opf
            this.dialog.client.data.legal.name.short = data.data.name.short_with_opf
            this.dialog.client.data.legal.inn = data.data.inn
            this.dialog.client.data.legal.kpp = data.data.kpp
            this.dialog.client.data.legal.ogrn = data.data.ogrn
            this.dialog.client.data.legal.ogrn_date = data.data.ogrn_date ? moment(new Date(data.data.ogrn_date)).format('YYYY-MM-DD') : ''
            this.dialog.client.data.legal.okved = data.data.okveds || [data.data.okved]
            this.dialog.client.data.legal.main_okved = data.data.okved
            this.dialog.client.data.legal.director = {}
            if (data.data.management) {
              this.dialog.client.data.legal.director.name = data.data.management.name
              this.dialog.client.data.legal.director.post = data.data.management.post
            }
            this.dialog.client.data.tax = data.data.tax || {}
            if (data.data.address) {
              this.dialog.client.data.legal.address = data.data.address
              this.dialog.client.data.addresses = [{
                value: data.data.address.unrestricted_value,
                data: data.data.address.data,
                type: 1,
              }]
            }

            this.dialog.client.data.legal.state = data.data.state
            this.dialog.client.data.state_text = this.legalStateToText(data.data.state.status)
          },
        })
      },
      legalStateToText: function (status) {
        let result = ''
        if (status) {
          switch (status) {
            case 'ACTIVE':
              result = 'Действующая'
              break
            case 'LIQUIDATING':
              result = 'Ликвидируется'
              break
            case 'LIQUIDATED':
              result = 'Ликвидирована'
              break
            case 'REORGANIZING':
              result = 'В процессе присоединения к другому юрлицу, с последующей ликвидацией'
              break
          }
        }
        return result
      },
      getDoc: function (item) {
        console.log(item)
        const form = $('<form>', {
          target: '_blank',
          action: '/api/common/file/get',
          method: 'post',
        })
        form.append(
          $('<input>', {
            type: 'hidden',
            value: item.id,
            name: 'id',
          })
        )
        form.appendTo('body').submit()
      },
      upload: function (event) {
        const files = event.target.files
        if (files[0]) {
          this.loader.show = true
          const data = new FormData()
          data.append('file', files[0])
          this.axios
            .post('/api/common/file/', data, {
              headers: {
                'Content-Type': 'multipart/form-data',
              },
            })
            .then(response => {
              if (response.data.error) {
                this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              } else {
                for (const x in response.data.data) {
                  this.dialog.client.data.files.push(response.data.data[x])
                }
              }
              this.loader.show = false
            })
            .catch(error => {
              console.log(error)
              this.$store.commit('snackbar', 'Ошибка при сохранении данных')
              this.loader.show = false
            })
        }
      },
    },
  }
</script>
